import axiosInstance from "./axiosInstance";
import Cookies from "js-cookie";

const blogService = {
  getAllBlogs: async () => {
    try {
      const response = await axiosInstance.get(`/blogs/all-blogs`, {
        // Public endpoint: do not attach Authorization header
        headers: { "X-Skip-Auth": true },
        skipAuth: true,
      });
      return response.data;
    } catch (error) {
      const normalized = {
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
        ...(error?.response?.data && typeof error.response.data === "object"
          ? error.response.data
          : {}),
      };
      throw normalized;
    }
  },
  getBlogById: async (id) => {
    try {
      const response = await axiosInstance.get(`/blogs/${id}`);
      return response.data;
    } catch (error) {
      const normalized = {
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
        ...(error?.response?.data && typeof error.response.data === "object"
          ? error.response.data
          : {}),
      };
      throw normalized;
    }
  },
  createBlog: async (payload) => {
    try {
      const formData = new FormData();
      Object.entries(payload || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });
      const token =
        Cookies.get("token") ||
        (typeof window !== "undefined"
          ? localStorage.getItem("token")
          : undefined);
      const response = await axiosInstance.post(
        `/blogs/create`,
        formData,
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
      );
      return response.data;
    } catch (error) {
      const normalized = {
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
        ...(error?.response?.data && typeof error.response.data === "object"
          ? error.response.data
          : {}),
      };
      throw normalized;
    }
  },
  updateBlog: async (id, payload) => {
    try {
      const formData = new FormData();
      Object.entries(payload || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });
      console.log(formData, "formData");

      const token =
        Cookies.get("token") ||
        (typeof window !== "undefined"
          ? localStorage.getItem("token")
          : undefined);
      const response = await axiosInstance.put(
        `/blogs/${id}`,
        formData,
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
      );
      return response.data;
    } catch (error) {
      const normalized = {
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
        ...(error?.response?.data && typeof error.response.data === "object"
          ? error.response.data
          : {}),
      };
      throw normalized;
    }
  },
  deleteBlog: async (id) => {
    try {
      const token =
        Cookies.get("token") ||
        (typeof window !== "undefined"
          ? localStorage.getItem("token")
          : undefined);
      const response = await axiosInstance.delete(
        `/blogs/${id}`,
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
      );
      return response.data;
    } catch (error) {
      const normalized = {
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
        ...(error?.response?.data && typeof error.response.data === "object"
          ? error.response.data
          : {}),
      };
      throw normalized;
    }
  },
};

export default blogService;
